'use client';

import clsx from 'clsx';
import React, { useId } from 'react';
import type { ToggleButtonVariantsProps } from './styles';
import { toggleButtonStyles, toggleLabelStyles, toggleSpanStyles } from './styles';

interface ToggleProps extends Omit<React.HTMLAttributes<HTMLButtonElement>, 'onChange'> {
  label?: string;
  id?: string;
  checked?: boolean;
  onChange?: (event: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLLabelElement>) => void;
  className?: string;
  disabled?: boolean;
  name?: string;
  value?: string;
  intent?: ToggleButtonVariantsProps['intent'];
}

export const Toggle: React.FC<ToggleProps> = ({
  label,
  id,
  checked = false,
  onChange,
  className,
  disabled = false,
  intent = 'default',
  ...props
}) => {
  const generatedId = useId();
  const RId = id || generatedId;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLLabelElement>) => {
    if (onChange && !disabled) {
      onChange(event);
    }
  };

  return (
    <div className={clsx('flex items-center', className)}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={handleClick}
        id={RId}
        disabled={disabled}
        className={clsx(toggleButtonStyles({ intent, checked, disabled }))}
        {...props}
      >
        <span aria-hidden="true" className={clsx(toggleSpanStyles({ intent, checked }))} />
      </button>
      {label && (
        <label onClick={handleClick} className={clsx(toggleLabelStyles({ intent, disabled }))}>
          {label}
        </label>
      )}
    </div>
  );
};
